import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Paper,
  Divider,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import libritoImg from '../assets/images/librito.png';

function Instructions() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Header title={t('buttons.instructions')} showBackButton={true} />
      <Container maxWidth="md" sx={{ mt: 2, mb: 4, pb: 8 }}>
        <Paper elevation={3} sx={{ p: 3 }}>
          {/* Conceptos Básicos */}
          <Typography variant="h4" component="h1" gutterBottom color="primary">
            {t('instructions.title')}
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
            {t('instructions.basic_concepts')}
          </Typography>

          <Box component="ul" sx={{ pl: 2 }}>
            <li><strong>{t('instructions.players')}:</strong> {t('instructions.players_desc')}</li>
            <li><strong>{t('instructions.deck')}:</strong> {t('instructions.deck_desc')}</li>
            <li><strong>{t('instructions.match')}:</strong> {t('instructions.match_desc')}</li>
            <li><strong>{t('instructions.game')}:</strong> {t('instructions.game_desc')}</li>
            <li>
              <strong>{t('instructions.scoring')}:</strong> {t('instructions.scoring_desc')}
              <ul>
                <li>{t('instructions.scoring_bad')}</li>
                <li>{t('instructions.scoring_good')}</li>
              </ul>
            </li>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* LA RONDA */}
          <Typography variant="h5" component="h2" gutterBottom color="primary">
            {t('instructions.ronda_title')}
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>{t('instructions.ronda_objective')}:</strong> {t('instructions.ronda_objective_desc')}
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.ronda_deal')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li>{t('instructions.ronda_deal_first')}</li>
            <li>{t('instructions.ronda_deal_next')}</li>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.ronda_plays')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li>{t('instructions.ronda_plays_collect')}</li>
            <li>{t('instructions.ronda_plays_cant')}</li>
            <li><strong>{t('instructions.ronda_plays_ronda').split(':')[0]}:</strong> {t('instructions.ronda_plays_ronda').split(':')[1]}</li>
            <li><strong>{t('instructions.ronda_plays_rondin').split(':')[0]}:</strong> {t('instructions.ronda_plays_rondin').split(':')[1]}</li>
            <li><strong>{t('instructions.ronda_plays_caida').split(':')[0]}:</strong> {t('instructions.ronda_plays_caida').split(':')[1]}</li>
            <li><strong>{t('instructions.ronda_plays_contra').split(':')[0]}:</strong> {t('instructions.ronda_plays_contra').split(':')[1]}</li>
            <li><strong>{t('instructions.ronda_plays_sanvicente').split(':')[0]}:</strong> {t('instructions.ronda_plays_sanvicente').split(':')[1]}</li>
            <li><strong>{t('instructions.ronda_plays_aseo').split(':')[0]}:</strong> {t('instructions.ronda_plays_aseo').split(':')[1]}</li>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.ronda_sends')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('instructions.ronda_sends_desc')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li>{t('instructions.ronda_sends_first')}</li>
            <li>{t('instructions.ronda_sends_options')}</li>
            <li>{t('instructions.ronda_sends_accept')}</li>
            <li>{t('instructions.ronda_sends_winner')}</li>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.ronda_scoring')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('instructions.ronda_scoring_desc')}
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* LA BÁCIGA */}
          <Typography variant="h5" component="h2" gutterBottom color="primary">
            {t('instructions.baciga_title')}
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>{t('instructions.baciga_objective')}:</strong> {t('instructions.baciga_objective_desc')}
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.baciga_values')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li>{t('instructions.baciga_values_numbers')}</li>
            <li>{t('instructions.baciga_values_figures')}</li>
            <li><strong>{t('instructions.baciga_values_wildcards').split(':')[0]}:</strong> {t('instructions.baciga_values_wildcards').split(':')[1]}</li>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.baciga_deal')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('instructions.baciga_deal_desc')}
          </Typography>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.baciga_phase1')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li><strong>{t('instructions.baciga_phase1_baciga').split(':')[0]}:</strong> {t('instructions.baciga_phase1_baciga').split(':')[1]}</li>
            <li><strong>{t('instructions.baciga_phase1_bacigote').split(':')[0]}:</strong> {t('instructions.baciga_phase1_bacigote').split(':')[1]}</li>
            <li><strong>{t('instructions.baciga_phase1_pass').split(':')[0]}:</strong> {t('instructions.baciga_phase1_pass').split(':')[1]}</li>
            <li><strong>{t('instructions.baciga_phase1_cartas').split(':')[0]}:</strong> {t('instructions.baciga_phase1_cartas').split(':')[1]}</li>
            <li>{t('instructions.baciga_phase1_winner')}</li>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.baciga_phase2')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li>{t('instructions.baciga_phase2_request')}</li>
            <li>{t('instructions.baciga_phase2_hide')}</li>
            <li><strong>{t('instructions.baciga_phase2_cosas').split(':')[0]}:</strong> {t('instructions.baciga_phase2_cosas').split(':')[1]}</li>
            <li><strong>{t('instructions.baciga_phase2_passed').split(':')[0]}:</strong> {t('instructions.baciga_phase2_passed').split(':')[1]}</li>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 2 }}>
            {t('instructions.baciga_scoring')}
          </Typography>
          <Box component="ol" sx={{ pl: 2 }}>
            <li>{t('instructions.baciga_scoring_pairs')}</li>
            <li>{t('instructions.baciga_scoring_baciga')}</li>
            <li>{t('instructions.baciga_scoring_highest')}</li>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Reglas de Cortesía */}
          <Typography variant="h5" component="h2" gutterBottom color="primary">
            {t('instructions.courtesy_title')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li><strong>{t('instructions.courtesy_media').split(':')[0]}:</strong> {t('instructions.courtesy_media').split(':')[1]}</li>
            <li><strong>{t('instructions.courtesy_otra').split(':')[0]}:</strong> {t('instructions.courtesy_otra').split(':')[1]}</li>
            <li><strong>{t('instructions.courtesy_sewan').split(':')[0]}:</strong> {t('instructions.courtesy_sewan').split(':')[1]}</li>
            <li><strong>{t('instructions.courtesy_knock').split(':')[0]}:</strong> {t('instructions.courtesy_knock').split(':')[1]}</li>
            <li><strong>{t('instructions.courtesy_passed').split(':')[0]}:</strong> {t('instructions.courtesy_passed').split(':')[1]}</li>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Finales Igualados */}
          <Typography variant="h5" component="h2" gutterBottom color="primary">
            {t('instructions.tie_title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('instructions.tie_desc')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li>{t('instructions.tie_dealer')}</li>
            <li>{t('instructions.tie_exception')}</li>
            <li>{t('instructions.tie_ronda')}</li>
            <li>{t('instructions.tie_baciga')}</li>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Créditos */}
          <Typography variant="h5" component="h2" gutterBottom color="primary">
            {t('instructions.credits_title')}
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            {t('instructions.credits_desc')}
          </Typography>
          <Box component="ul" sx={{ pl: 2 }}>
            <li>
              <Typography variant="body2" color="text.secondary">
                <strong>{t('instructions.credits_bengala').split(' - ')[0]}</strong> - {t('instructions.credits_bengala').split(' - ')[1]}
              </Typography>
            </li>
            <li>
              <Typography variant="body2" color="text.secondary">
                <strong>{t('instructions.credits_velasco').split(' - ')[0]}</strong> - {t('instructions.credits_velasco').split(' - ')[1]}
              </Typography>
            </li>
          </Box>

          {/* Libro disponible */}
          <Box
            sx={{
              mt: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Box
              component="img"
              src={libritoImg}
              alt={t('instructions.book_alt')}
              sx={{
                width: 120,
                height: 'auto',
                transform: 'rotate(-5deg)',
                boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)',
                filter: 'drop-shadow(0 0 8px rgba(0, 0, 0, 0.2))',
                mb: 2,
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400 }}>
              {t('instructions.book_available')}
            </Typography>
          </Box>
        </Paper>
      </Container>

      {/* Back Button Footer */}
      <Paper
        elevation={10}
        sx={{
          p: 2,
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)'
        }}
      >
        <Container maxWidth="md">
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => navigate('/')}
            startIcon={<ArrowBackIcon />}
            sx={{
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 'bold',
              borderRadius: 3,
            }}
          >
            {t('common.home')}
          </Button>
        </Container>
      </Paper>
    </>
  );
}

export default Instructions;
